// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.discriminator = undefined;
EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.additionalProperties = false;
EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.attributeTypeMap = [
    {
        "name": "diagnosisIds",
        "baseName": "diagnosisIds",
        "type": "Array<number>"
    },
    {
        "name": "diagnosisCodes",
        "baseName": "diagnosisCodes",
        "type": "Array<string>"
    },
    {
        "name": "delimitedCodes",
        "baseName": "delimitedCodes",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.js.map